import './ModelUpload.scss';

export { default } from './ModelUpload';
